// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"fe7cda58","695":"4c809a45","730":"bee7d993","838":"b09e37ce"}[chunkId] + ".chunk.js";
};